import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {  oppage } from 'src/app/util/animations.util';

@Component({
  selector: 'app-order',
  templateUrl: './order.component.html',
  styleUrls: ['./order.component.css'],
  animations: [
    oppage,
  ]
})
export class OrderComponent implements OnInit {

  constructor(
  ) { }

  ngOnInit(): void {
  }
  prepareRoute(outlet: RouterOutlet): string | void {
    return outlet && outlet.activatedRouteData.animation;
  }
}
